import { render, staticRenderFns } from "./blog-home-category.vue?vue&type=template&id=bf2d94fc&"
import script from "./blog-home-category.vue?vue&type=script&lang=js&"
export * from "./blog-home-category.vue?vue&type=script&lang=js&"
import style0 from "./blog-home-category.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports